<template>
    <b-container fluid>
      <b-row class="rows">
        <b-col>
          <card class="deviceGroupTable">
            <TableActionHeader
              v-on:filterChange="onFilterChange"
              v-on:newItem="onNewItem"
              :newButton="$UIPrivilegeCreate('devices', 'ssedisplay_groups')"
            />
            <DeviceGroupTable :filter="filter" v-on:selectItem="onSelectItem" />
          </card>
        </b-col>
        <b-col>
          <info-card class ="deviceGroupEdit" v-if="formType == ''" />
          <card v-if="formType == 'new'">
            <CardHeader :title="$t('item.new')" />
            <DisplayGroupForm :action="formType" />
          </card>
          <card class="deviceGroupEdit" v-if="formType === 'edit'">
            <CardHeader :title="$t('item.edit') + ': ' + this.itemName" />
            <DisplayGroupForm
              :item="item"
              @itemName="handleItemName"
              :action="formType"
            />
          </card>
        </b-col>
      </b-row>
    </b-container>
  </template>
  
  <script>
  import TableActionHeader from '@/components/Misc/TableActionHeader'
  import DeviceGroupTable from '@/components/Devices/DeviceGroup/DeviceGroupTable.vue'
  import DisplayGroupForm from '@/components/Display/DisplayGroupForm.vue'
  import InfoCard from '@/components/Misc/InfoCard.vue'

  export default {
    name: 'DisplayGroups',
    components: {
      TableActionHeader,
      DeviceGroupTable,
      DisplayGroupForm,
      InfoCard,
    },
    data: function () {
      return {
        showForm: true,
        cols: 8,
        filter: null,
        formType: '',
        item: null,
        itemName: '', // original item.name
      }
    },
    methods: {
      onFilterChange(filter) {
        this.filter = filter
        this.toggleFormVisibility(true, '')
      },
      toggleFormVisibility(isVisible, formType) {
        this.showForm = isVisible
        this.formType = formType
        this.cols = this.showForm ? 8 : 12
      },
      onNewItem() {
        this.item = null
        this.toggleFormVisibility(true, 'new')
      },
      onSelectItem(item) {
        if (item) {
          this.item = JSON.parse(JSON.stringify(item))
          this.toggleFormVisibility(true, 'edit')
          this.itemName = this.item.name
        }
      },
      handleItemName(itemName) {
        this.itemName = itemName
      },
    },
  }
  </script>
  
  <style scoped lang="scss">


    .deviceGroupTable {
         min-width: 30em;
    }
    .deviceGroupEdit {
         width: 40em;
    }
    
</style>